/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SubscriptionPriceInterval = {
    DAY: 'DAY',
    MONTH: 'MONTH',
    YEAR: 'YEAR'
} as const;
export type SubscriptionPriceInterval = typeof SubscriptionPriceInterval[keyof typeof SubscriptionPriceInterval];


export function instanceOfSubscriptionPriceInterval(value: any): boolean {
    for (const key in SubscriptionPriceInterval) {
        if (Object.prototype.hasOwnProperty.call(SubscriptionPriceInterval, key)) {
            if (SubscriptionPriceInterval[key as keyof typeof SubscriptionPriceInterval] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SubscriptionPriceIntervalFromJSON(json: any): SubscriptionPriceInterval {
    return SubscriptionPriceIntervalFromJSONTyped(json, false);
}

export function SubscriptionPriceIntervalFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionPriceInterval {
    return json as SubscriptionPriceInterval;
}

export function SubscriptionPriceIntervalToJSON(value?: SubscriptionPriceInterval | null): any {
    return value as any;
}

export function SubscriptionPriceIntervalToJSONTyped(value: any, ignoreDiscriminator: boolean): SubscriptionPriceInterval {
    return value as SubscriptionPriceInterval;
}

